import {styled} from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Stack from '@mui/material/Stack';
import MuiToolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import React, {useState} from 'react';
import SideMenuMobile from './sideBar/SideMenuMobile';
import MenuButton from '../common/MenuButton';
import {usePageTitle} from '../../hooks/usePageTitle';
import {useMobileHeaderActions} from '../../context/MobileHeaderActionsContext';
import {useLocation} from 'react-router-dom';
import {useMediaQuery} from "@mui/material";
import {theme} from "../../styles/theme/theme";
import {MOBILE_NAVBAR_HEIGHT} from "./layout.constants";

const Toolbar = styled(MuiToolbar)({
    width: '100%',
    paddingInline: '12px',
    display: 'flex',
    flexDirection: 'row',          // было column — артефакт, контент в одну строку
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    // Фиксируем высоту, чтобы не прыгала на брейкпоинте sm (MuiToolbar по
    // умолчанию 56px <600 и 64px ≥600 — этот излом и ломал компенсацию pt).
    minHeight: `${MOBILE_NAVBAR_HEIGHT}px !important`,
    height: `${MOBILE_NAVBAR_HEIGHT}px`,
});

const AppNavbar = () => {
    const [open, setOpen] = useState(false);
    const routeTitle = usePageTitle();
    const {title: dynamicTitle, actions, seamlessBottom} = useMobileHeaderActions();
    const location = useLocation();
    const isMapPage = location.pathname.startsWith('/map');
    const toggleDrawer = (newOpen: boolean) => () => {
        setOpen(newOpen);
    };
    const isPhone = useMediaQuery(theme.breakpoints.down('sm'));

    // Динамический заголовок (имя машины и т.п.) приоритетнее титула роута.
    const headerTitle = dynamicTitle ?? routeTitle;

    if (isMapPage && isPhone) {
        return (
            <>
                <MenuButton
                    aria-label="menu"
                    onClick={toggleDrawer(true)}
                    sx={{
                        display: {xs: 'flex', md: 'none'},
                        position: 'fixed',
                        top: 12,
                        right: 12,
                        zIndex: 1300,
                        width: '32px',
                        height: '32px',
                        bgcolor: 'background.paper',
                        border: '1px solid',
                        borderColor: 'divider',
                        borderRadius: '8px',
                        boxShadow: 'none',
                        color: 'text.primary',
                        '&:hover': {
                            bgcolor: 'grey.200',
                            '[data-dark] &': {
                                bgcolor: 'grey.700',
                            },
                        },
                    }}
                >
                    <MenuRoundedIcon sx={{fontSize: 18}}/>
                </MenuButton>
                <SideMenuMobile open={open} toggleDrawer={toggleDrawer}/>
            </>
        );
    }

    return (
        <AppBar
            position="fixed"
            sx={{
                display: {xs: 'auto', md: 'none'},
                boxShadow: 0,
                bgcolor: 'background.paper',
                backgroundImage: 'none',
                // Линию гасим, когда страница сообщает, что под навбаром идёт
                // свой отделяющий элемент (полоса табов со своей границей) —
                // иначе две параллельные линии подряд.
                borderBottom: seamlessBottom ? 'none' : '1px solid',
                borderColor: 'divider',
                top: 'var(--template-frame-height, 0px)',
                zIndex: 1300,
            }}
        >
            <Toolbar variant="regular">
                <Stack
                    direction="row"
                    sx={{
                        alignItems: 'center',
                        flexGrow: 1,
                        width: '100%',
                        gap: 1,
                    }}
                >
                    {/* Заголовок страницы (динамический из контекста или титул роута) */}
                    <Typography
                        variant="h6"
                        component="h1"
                        noWrap
                        sx={{
                            color: 'text.primary',
                            flexGrow: 1,
                            fontWeight: 600,
                        }}
                    >
                        {headerTitle}
                    </Typography>
                    {/* Кнопки действий страницы */}
                    {actions}
                    {/* Бургер-меню */}
                    <MenuButton aria-label="menu" onClick={toggleDrawer(true)}>
                        <MenuRoundedIcon/>
                    </MenuButton>
                    <SideMenuMobile open={open} toggleDrawer={toggleDrawer}/>
                </Stack>
            </Toolbar>
        </AppBar>
    );
}

export default AppNavbar